class Magnifier {
    constructor(container, productImageClassName) {
        this.container = container.get(0); // 存储当前容器
        this.productImage = $(container).find('.'+productImageClassName)[0]; // 获取产品图片
        this.zoomedImage = null; // 存储放大镜元素
        this.zoomedIn = false; // 放大状态标志
        this.zoomFactor = 2; // 放大倍数

        // 初始化事件
        this.init();
    }

    init() {
        // 点击事件，切换放大镜状态
        $(this.container).on('click', (event) => this.toggleMagnifier(event));
        // 鼠标移动事件，更新放大镜位置
        $(this.container).on('mousemove', (event) => this.updateZoomedImagePosition(event));
        // 鼠标移出事件，关闭放大镜
        $(this.container).on('mouseleave', () => this.closeMagnifier());
    }

    toggleMagnifier(event) {
        const { left, top } = this.container.getBoundingClientRect(); // 获取容器位置
        const x = event.clientX - left; // 计算鼠标相对位置
        const y = event.clientY - top;

        if (!this.zoomedIn) {
            // 创建并配置放大镜元素
            this.zoomedImage = document.createElement('div');
            this.zoomedImage.className = 'zoomed-image';
            const imageUrl = this.productImage.src; // 获取 img 标签的 src 属性
            this.zoomedImage.style.backgroundImage = `url('${imageUrl}')`;
            this.zoomedImage.style.backgroundSize = `${this.productImage.width * this.zoomFactor}px ${this.productImage.height * this.zoomFactor}px`; // 设置放大背景图比例
            this.container.appendChild(this.zoomedImage); // 添加到容器
        }

        // 切换放大状态
        this.zoomedIn = !this.zoomedIn;
        this.zoomedImage.style.display = this.zoomedIn ? 'block' : 'n2g one'; // 显示或隐藏放大镜

        if (this.zoomedIn) {
            this.container.style.cursor = 'zoom-out';
            this.updateZoomedImagePosition(event); // 更新位置
        } else {
            this.closeMagnifier(); // 退出时移除放大镜元素
        }
    }

    updateZoomedImagePosition(event) {
        if (!this.zoomedIn) return; // 如果未放大，则不处理

        const { left, top } = this.container.getBoundingClientRect(); // 获取容器位置
        const x = event.clientX - left; // 计算鼠标相对位置
        const y = event.clientY - top;

        // 计算背景位置
        const bgX = Math.max(0, Math.min((x / this.productImage.width) * 100, 100));
        const bgY = Math.max(0, Math.min((y / this.productImage.height) * 100, 100));
        this.zoomedImage.style.backgroundPosition = `${bgX}% ${bgY}%`; // 设置背景位置
    }

    closeMagnifier() {
        if (this.zoomedImage) {
            this.zoomedIn = false; // 关闭放大状态
            this.zoomedImage.style.display = 'none'; // 隐藏放大镜
            this.container.removeChild(this.zoomedImage); // 移除放大镜元素
            this.zoomedImage = null; // 重置引用
            this.container.style.cursor = 'zoom-in';
        }
    }
}